module.exports = __webpack_public_path__ + "img/Entia-Carreteras-y-edificaciones-11.59fed2f9.webp";